import { Form, Input, Modal, message } from 'antd';
import { FC, memo, useCallback, useState } from 'react';
import {
  updateAdminPassword,
  updateTranslatorPassword
} from 'services/api/users';

import { showErrorMessage } from 'utils/showErrorMessage';

interface IProps {
  onClose(): void;
  id?: string;
  // Selects between the two admin password-update endpoints. `admin`
  // is the default since the only opener today (Admins page) targets
  // admin users.
  role?: 'admin' | 'translator';
}

const ChangeUserPassword: FC<IProps> = ({ id, onClose, role = 'admin' }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    onClose();
    form.resetFields();
  };

  const onFinish = useCallback(
    async (values: { password: string }) => {
      if (!id) return;

      try {
        setLoading(true);

        if (role === 'translator') {
          await updateTranslatorPassword(id, values.password);
        } else {
          await updateAdminPassword(id, values.password);
        }

        message.success('Successfully updated');
        closeModal();
      } catch (err) {
        showErrorMessage(err);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, role]
  );

  return (
    <Modal
      open
      title="Change password"
      onCancel={closeModal}
      width={600}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} onFinish={onFinish} layout="vertical" size="large">
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(ChangeUserPassword);
